type DeadLinkNotice = { type: "info" | "error"; message: string };

// A 401 here means the welcome link is spent; the form can never succeed, so say so and send them to login.
const deadLinkNotice = (error: any): DeadLinkNotice | null => {
  if (error?.response?.status !== 401) {
    return null;
  }

  const raw = error?.response?.data?.message;
  const text = (
    Array.isArray(raw) ? raw.join(" ") : String(raw ?? "")
  ).toLowerCase();

  if (text.includes("used")) {
    return {
      type: "info",
      message:
        "This link has already been used — your password is set. Please log in.",
    };
  }

  return {
    type: "error",
    message:
      "This link is no longer valid. Please log in, or use Forgot Password to choose a new one.",
  };
};

export default deadLinkNotice;
